'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Skeleton_web = require('../../../atoms/Skeleton/Skeleton.web.cjs');
var VariantDropdown_web = require('../../VariantDropdown/VariantDropdown.web.cjs');
var VariantDropdown_web_styles = require('./VariantDropdown.web.styles.cjs');

/**
 *  Description added in ProductCard.web.tsx
 */ const VariantDropdown = ({ isLoading, ...rest })=>{
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: VariantDropdown_web_styles.wrapper,
        children: isLoading ? /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
            type: "typography",
            typographyType: "footnote"
        }) : /*#__PURE__*/ jsxRuntime.jsx(VariantDropdown_web.VariantDropdown, {
            ...rest
        })
    });
};

exports.VariantDropdown = VariantDropdown;
//# sourceMappingURL=VariantDropdown.web.cjs.map
